import React from "react";
import { useTranslation } from "react-i18next";
import dayjs from "dayjs";
import { startCase } from "lodash";
import ViewInfo from "components/reusable/ViewInfo";

const OfferView = ({ setOfferView, currentItem }) => {
  const { t } = useTranslation();

  return (
    <>
      <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
        <div className="relative w-auto my-6 mx-auto max-w-3xl">
          <form className="sm:py-4 sm:px-2 py-8 px-7">
            <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none min-w-[940px] max-h-[96vh] overflow-y-auto	">
              <div className="flex items-center justify-between p-5 border-b border-solid border-slate-200 rounded-t">
                <h3 className="text-xl font-semibold">{t("O_VIEW_USER")}</h3>
                <button className=" ml-auto flex items-center justify-center  text-black border-2 rounded-full  h-8 w-8 float-right text-3xl leading-none font-extralight outline-none focus:outline-none" onClick={() => setOfferView(false)}>
                  <span className=" text-[#B8BBBF]  text-4xl " title="Close">
                    ×
                  </span>
                </button>
              </div>
              <div className="relative p-6 flex-auto">
                <h3 className="text-xl font-semibold">Employee Details</h3>
                <div className="grid grid-cols-3">
                  <ViewInfo label="Employee ID" value={currentItem?.Employee?.employeeId} />
                  <ViewInfo label="Employee name" value={currentItem?.Employee?.name} />
                  <ViewInfo label="Email ID" value={currentItem?.Employee?.email} />
                  <ViewInfo label="Year of experience" value={currentItem.yearOfExperiece} />
                  <ViewInfo label="DOB" value={dayjs(currentItem?.Employee?.dob).format("MM-DD-YYYY ")} />
                  <ViewInfo label="Country" value={currentItem?.EmployeeCountry?.name} />
                  <ViewInfo label="State" value={currentItem?.EmployeeState?.name} />
                  <ViewInfo label="City" value={currentItem?.Employee?.city} />

                  <ViewInfo label="Skills" value={currentItem?.EmployeeSkills?.map((item) => item?.name).join(", ")} />
                  <ViewInfo label="Job Applied Date" value={dayjs(currentItem?.createdAt).format("MM-DD-YYYY ")} />
                  <ViewInfo label="Accepted and rejected date" value={dayjs(currentItem?.acceptedRejectedAt).format("MM-DD-YYYY ")} />
                  <ViewInfo label="Duration Type" value={currentItem?.duration} />
                </div>
                <h3 className="text-xl font-semibold">Job Details</h3>
                <div className="grid grid-cols-3">
                  <ViewInfo label="Job Title" value={currentItem?.Job?.name} />
                  <ViewInfo label="Job Country" value={currentItem?.JobCountry?.name} />
                  <ViewInfo label="Job State" value={currentItem?.JobState?.name} />
                  <ViewInfo label="Job City" value={currentItem?.Job?.city} />
                  <ViewInfo label="Job Category" value={currentItem?.JobCategory?.name} />
                  <ViewInfo label="Job SubCategory" value={currentItem?.JobSubCategory?.name} />
                  <ViewInfo label="Job Department" value={currentItem?.JobDepartment?.name} />
                  <ViewInfo label="Job Employment Length" value={currentItem?.Job?.employmentLength || 0} />
                  <ViewInfo label="Job Created Date" value={dayjs(currentItem?.Job?.createdAt).format("MM-DD-YYYY ")} />
                  <ViewInfo label="Job Skills" value={currentItem?.JobSkills?.map((item) => item?.name).join(", ") || ""} />
                  <div className='sm:py-4 sm:px-2 py-8 px-7'>
                    <div className='relative z-0 mb-2 w-full group'>
                      <strong>{"Job Description"}</strong>
                      {/* <h6>{currentItem?.Job?.description}</h6> */}
                      <div className="inner-html" dangerouslySetInnerHTML={{ __html: currentItem?.Job?.description }} />
                    </div>
                  </div>
                  <div className='sm:py-4 sm:px-2 py-8 px-7'>
                    <div className='relative z-0 mb-2 w-full group'>
                      <strong>{"Job Terms & Condition"}</strong>
                      {/* <h6>{currentItem?.Job?.terminationCondition}</h6> */}
                      <div className="inner-html" dangerouslySetInnerHTML={{ __html: currentItem?.Job?.terminationCondition }} />
                    </div>
                  </div>
                </div>
                <h3 className="text-xl font-semibold">Offer Letter Details</h3>
                <div className="grid grid-cols-3">
                  <ViewInfo label="Offer Letter Status" value={startCase(currentItem?.offerLetterStatus)} />
                </div>
              </div>
              <div className="flex items-center justify-center p-6 border-t border-solid border-slate-200 rounded-b">
                <button className="text-black bg-[#E1E1E1] font-normal px-12 py-2.5 text-sm outline-none focus:outline-none rounded mr-6  ease-linear transition-all duration-150" type="button" onClick={() => setOfferView(false)}>
                  {t("O_BACK")}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
      <div className="opacity-25 fixed inset-0 z-40 bg-black" />
    </>
  );
};

export default OfferView;
